import { render, staticRenderFns } from "./CardIndicatorInfo.vue?vue&type=template&id=20895bb5&scoped=true&"
import script from "./CardIndicatorInfo.vue?vue&type=script&lang=js&"
export * from "./CardIndicatorInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardIndicatorInfo.vue?vue&type=style&index=0&id=20895bb5&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20895bb5",
  null
  
)

export default component.exports